<template>
	<v-slide-group
		mandatory
		center-active
		class="pa-0 ma-0 pt-2 pb-2 slide-group"
		:show-arrows="$vuetify.breakpointmdAndUp"
	>
		<template v-slot:prev>
			<v-btn fab elevation="5" color="white" class="control control-prev">
				<v-icon class="blue--text">
					mdi-chevron-left
				</v-icon>
			</v-btn>
		</template>

		<template v-slot:next>
			<v-btn fab elevation="5" color="white" class="control control-next">
				<v-icon class="blue--text">
					mdi-chevron-right
				</v-icon>
			</v-btn>
		</template>

		<v-slide-item v-for="(product, key) in Products" class="ma-0 ml-1 mr-1">
			<v-card class="pa-0" flat width="275px" color="transparent">
				<v-container fluid>
					<v-row>
						<v-col cols="12" class="pa-0">
							<Product
								:product="product"
								:active="key == vModel"
							></Product>
						</v-col>
					</v-row>
				</v-container>
			</v-card>
		</v-slide-item>
	</v-slide-group>
</template>

<script>
import Product from "@/components/Product/Product";

export default {
	name: "VCarousel",

	props: {
		products: {
			type: Array,
			required: true,
		},

		value: {
			type: Number,
			required: false,
		},
	},

	components: { Product },

	data() {
		return {
			active: null,

			ui: {
				limit: 10,
			},
		};
	},

	computed: {
		Products() {
			return this.products
				? this.products.filter((article, key) => key < this.ui.limit)
				: [];
		},

		vModel: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit("input", newValue);
			},
		},
	},
};
</script>

<style lang="css" scoped>
.slide-group {
	background-color: #eee;
}
.control {
	z-index: 10;
}

.control-prev {
	left: -5px;
}

.control-next {
	right: -5px;
}

.v-slide-group__prev {
	background-color: red;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 600px) {
	.control-prev {
		left: 10px;
	}

	.control-next {
		right: 10px;
	}
}

/*Small	sm	Small to medium tablet	600px > < 960px*/
@media (min-width: 601px) and (max-width: 960px) {
	.control-prev {
		left: 10px;
	}

	.control-next {
		right: 10px;
	}
}

/*Medium	md	Large tablet to laptop	960px > < 1264px**/
@media (min-width: 961px) and (max-width: 1264px) {
}

/*Large	lg	Desktop	1264px > < 1904px**/
@media (min-width: 1265px) and (max-width: 1904px) {
}

/*Extra large	xl	4k and ultra-wide*/
@media (min-width: 1904px) {
}
</style>
